export default __webpack_public_path__ + "77e969fa810336872903cb2d34ba917e.png";